import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import {
  CreateCrtPeriodDetailsDialog,
  getDefaultImportPeriod,
} from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import {
  calculationRunAccrualsSearchSchema,
  useCreateCalculationRunAccrual,
} from '@/hooks/queries/crt/useCalculationRunAccruals'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CalculationRunAccrualsDataTable from './-components/CalculationRunAccrualsDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/insights/calculation-run-accruals/',
)({
  component: RouteComponent,
  validateSearch: (search) => calculationRunAccrualsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateCalculationRunAccrual({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('calculationRunAccruals.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_calculation_run_accruals_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('calculationRunAccruals.createButton')}
            title={t('createCalculationRunAccrualDialog.title')}
            nameLabel={t('createCalculationRunAccrualDialog.name.label')}
            namePlaceholder={t('createCalculationRunAccrualDialog.name.placeholder')}
            isPending={isPending}
            crtPeriodLabel={t('period')}
            defaultCrtPeriod={getDefaultImportPeriod()}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, period: crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('calculationRunAccruals.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <CalculationRunAccrualsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
